import React from 'react';
import { Tooltip as PaperTooltip } from 'react-native-paper';
import { Colors } from '../constants/Colors';

type Props = {
  title: string;
  children: React.ReactElement;
};

export const Tooltip = ({ title, children }: Props) => {
  return (
    <PaperTooltip
      title={title}
      theme={{
        colors: {
          surface: Colors.purple0,
          onSurface: Colors.text,
        },
      }}
    >
      {children}
    </PaperTooltip>
  );
};
